module.exports = __webpack_public_path__ + "static/media/15.858fd804.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/15.jpg
// module id = 83
// module chunks = 0